import { render, staticRenderFns } from "./ScreenBodegaPedido.vue?vue&type=template&id=6d6db277"
import script from "./ScreenBodegaPedido.vue?vue&type=script&lang=js"
export * from "./ScreenBodegaPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports